import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import realisticIsraelImg from "../../../../assests/realisticIsrael/realisticIsraelImg.png";

const RealisticIsraelCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#06094c"
            image={realisticIsraelImg}
            imageAlt={texts.realisticIsrael}
            link={`/${pathRouts.REALISTICISRAEL}`}
            imageFill
        />
    );
};

export default RealisticIsraelCarouselWidget;
